import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FileSelector from "vue-file-selector";
import VueMask from "v-mask";
import axios from "axios";
// import VueHtml2Canvas from "vue-html2canvas";

// Configure axios to send credentials (cookies) with requests
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;
Vue.use(FileSelector);
Vue.use(VueMask);
// Vue.use(VueHtml2Canvas);

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
